(function () {

	var sitemapWrapper = document.querySelector('.js-sitemap');

	if (!sitemapWrapper) return;

	setupSitemap(sitemapWrapper);

	var parentTabContent = sitemapWrapper.closest('[data-tabs-content]');
	if (parentTabContent) {
		parentTabContent.addEventListener('tabActivated', function() {
			equalizeTitleHeights();
		});
	}

	function setupSitemap(wrapper) {
		var panels = wrapper.querySelectorAll('.js-sitemap__panel');
		var buttons = wrapper.querySelectorAll('.js-sitemap__title__group__button');
		var expandMessage = wrapper.getAttribute('data-expand') || 'Expand all';
		var collapseMessage = wrapper.getAttribute('data-collapse') || 'Collapse all';
		var toggle = wrapper.querySelector('.js-sitemap-toggle');
		var isExpanded = false;

		equalizeTitleHeights();
		window.addEventListener('resize', equalizeTitleHeights);

		toggle.addEventListener('click', function (e) {
			e.preventDefault();

			if (isExpanded) {
				togglePanels(panels, buttons, false);
				updateToggle(toggle, expandMessage);
				isExpanded = false;
			} else {
				togglePanels(panels, buttons, true);
				updateToggle(toggle, collapseMessage);
				isExpanded = true;
			}
		});

		buttons.forEach(function (button, index) {
			button.addEventListener('click', function (e) {
				e.preventDefault();

				var panel = panels[index];
				var isButtonExpanded = button.classList.contains('expanded');

				if (isButtonExpanded) {
					panel.style.display = 'none';
					button.classList.remove('expanded');
				} else {
					panel.style.display = 'block';
					button.classList.add('expanded');
				}

				checkAllPanelsState(panels, toggle, expandMessage, collapseMessage);
				updateIndividualAriaExpanded(buttons, panels);
			});
		});
	}

	function togglePanels(panels, buttons, expand) {
		panels.forEach(function (panel, index) {
			if (expand) {
				panel.style.display = 'block';
				buttons[index].classList.add('expanded');
				buttons[index].setAttribute('aria-expanded', 'true');
			} else {
				panel.style.display = 'none';
				buttons[index].classList.remove('expanded');
				buttons[index].setAttribute('aria-expanded', 'false');
			}
		});
	}

	function updateIndividualAriaExpanded(buttons, panels) {
		buttons.forEach(function (button, index) {
			var panel = panels[index];
			if (panel.style.display === 'block') {
				button.setAttribute('aria-expanded', 'true');
			} else {
				button.setAttribute('aria-expanded', 'false');
			}
		});
	}

	function updateToggle(toggle, message) {
		toggle.textContent = message;
	}

	function checkAllPanelsState(panels, toggle, expandMessage, collapseMessage) {
		var allExpanded = Array.from(panels).every(function (panel) {
			return panel.style.display === 'block';
		});
		var anyExpanded = Array.from(panels).some(function (panel) {
			return panel.style.display === 'block';
		});

		if (allExpanded) {
			updateToggle(toggle, collapseMessage);
		} else if (!anyExpanded) {
			updateToggle(toggle, expandMessage);
		}
	}

	function equalizeTitleHeights() {
		if (window.innerWidth < 768) {
			document.querySelectorAll('.c-sitemap__title').forEach(function (title) {
				title.style.height = 'auto';
			});
			return;
		}

		document.querySelectorAll('.c-sitemap__title').forEach(el => el.style.height = 'auto');

		const cols = document.querySelectorAll('.c-grid__col');
		for (let i = 0; i < cols.length; i += 2) {
			const firstTitle = cols[i].querySelector('.c-sitemap__title');
			const secondTitle = cols[i + 1]?.querySelector('.c-sitemap__title');

			if (firstTitle && secondTitle) {
				const maxHeight = Math.max(firstTitle.offsetHeight, secondTitle.offsetHeight);
				firstTitle.style.height = `${maxHeight}px`;
				secondTitle.style.height = `${maxHeight}px`;
			}
		}
	}
})();
